<template>
  <v-expansion-panels v-model="panels" multiple>
    <v-expansion-panel v-for="plan in groupedPlans" :key="plan.planId">
      <v-subheader
        v-if="Boolean(plan.header)"
        class="text-subtitle-1 ma-2 grey lighten-4"
        >{{ plan.header.toUpperCase() }}</v-subheader
      >
      <template v-else>
        <v-expansion-panel-header class="flex-row-reverse">
          <v-card-title>
            {{ plan.planType }}: {{ plan.formattedStartDate }}
            <client-plan-form
              :plan="plan"
              :viewOnly="!canEdit(plan)"
            ></client-plan-form>
            <div class="d-flex flex-nowrap">
              <delete-modal
                v-if="canEdit(plan)"
                :disabled="!canDelete(plan)"
                disabledTooltip="Cannot remove plan with service plans"
                title="Are you sure you want to REMOVE this plan?"
                message="Note: This action cannot be undone."
                @save="deletePlan($event, plan)"
              ></delete-modal>
              <v-tooltip v-if="canReopen(plan)" bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    small
                    color="primary"
                    @click="reopenPlan(plan)"
                    >mdi-reload</v-icon
                  >
                </template>
                <span>Reopen plan</span>
                <confirm-modal ref="confirm"></confirm-modal>
              </v-tooltip>
            </div>
          </v-card-title>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <service-plans-table
            :planId="plan.planId"
            :viewOnly="!canEdit(plan)"
          ></service-plans-table>
        </v-expansion-panel-content>
      </template>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import ClientPlanForm from "./client-plan-form";
import ServicePlansTable from "./service-plans-table";
import DeleteModal from "../../Shared/delete-modal";
import ConfirmModal from "../../Shared/confirm-modal";

export default {
  components: { ClientPlanForm, ServicePlansTable, DeleteModal, ConfirmModal },
  props: ["plans", "active", "viewOnly"],
  data() {
    return {
      panels: this.active ? [...this.plans.keys()] : [],
    };
  },
  computed: {
    isSEITAdmin() {
      return this.$store.getters["securityModule/isSEITAdmin"];
    },
    planTypes() {
      return this.$store.state.optionsModule.planTypes;
    },
    groupedPlans: function () {
      const groups = Object.groupBy(this.plans, (plan) => plan.ageCategory);
      return Object.keys(groups).flatMap((category) => [
        { header: category },
        ...groups[category],
      ]);
    },
  },
  methods: {
    canEdit(plan) {
      return (
        this.isSEITAdmin &&
        !this.viewOnly &&
        plan.isActive &&
        plan.ageCategory == "Preschool"
      );
    },
    canDelete(plan) {
      return plan.servicePlans.length == 0;
    },
    canReopen(plan) {
      // can only reopen plan if there are no active plans
      return (
        this.isSEITAdmin &&
        !this.viewOnly &&
        !plan.isActive &&
        plan.ageCategory == "Preschool" &&
        !this.$store.getters["plansModule/getHasActivePlans"]
      );
    },
    deletePlan: async function (comments, plan) {
      this.$store.commit("uxModule/setShowLoader", true);
      var message = await this.$store.dispatch("plansModule/deletePlan", {
        planId: plan.planId,
        comments: comments,
      });
      this.$store.commit("uxModule/setShowLoader", false);
      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
    },
    reopenPlan: async function (plan) {
      if (
        await this.$refs.confirm[0].open(
          "Are you sure you want to reopen this plan?",
          ""
        )
      ) {
        this.$store.commit("uxModule/setShowLoader", true);
        var message = await this.$store.dispatch("plansModule/updatePlan", {
          ...plan,
          closureDate: null,
        });
        this.$store.commit("uxModule/setShowLoader", false);
        if (message) {
          this.$store.commit("uxModule/setSnackbarMsg", message);
          this.$store.commit("uxModule/setShowSnackbar", true);
        }
      }
    },
  },
};
</script>
